import styled, { css } from 'styled-components';
import { depthVariant, radiusVariant, theme } from './theme';
import { PaperProps } from './PaperProps';

/**
 * Basic surface with radius and shadow defined by design system.
 * It should be used to create menu/popover surfaces and much more.
 */
export const Paper = styled.div<PaperProps>`
  background-color: ${theme.background};
  box-shadow: ${depthVariant((variant) => variant.shadow)};
  border-radius: ${radiusVariant((variant) => variant.radius)};
  ${(props) =>
    props.isPadded &&
    css`
      padding: ${radiusVariant((variant) => variant.padding)};
    `}
`;
